
  import { Vue, Component, Prop } from 'vue-property-decorator'
  import date from 'date-and-time';
  import jwt_decode from "jwt-decode"

  @Component
  export default class BookingDialog extends Vue {
      @Prop(Number) readonly timeStart: number | undefined
      @Prop(Number) readonly timeEnd: number | undefined
      @Prop(String) readonly space: string | undefined
      @Prop(String) readonly token: string | undefined
      @Prop(Object) existingEvent: any | undefined

      public eventModel: any = {}; 
      public bookingform: any[] = []; 

      public beforeUpdate() {
        this.eventModel = this.existingEvent;
      }

      public async mounted() {
        let response;

        this.eventModel = this.existingEvent;

        if( process.env.NODE_ENV === 'development' ) {
          response = await fetch(`http://localhost:7071/api/getSpaceBookingProps?space=${this.space}&token=${this.token}`).then(res => res.json());
        } else {
          response = await fetch(`/api/getSpaceBookingProps?space=${this.space}&token=${this.token}`).then(res => res.json());
        }
       
       this.bookingform = response.bookingform;
      }

      public clearEventmodel() {
        this.eventModel = {};
      }

      public canAdmin(){
        if( this.token ) {
          const tokendata: any = jwt_decode( this.token as string );
          return tokendata.admin.indexOf( this.space ) > -1 ;
        }

        return false;
      }

      public formatTime( timestamp: number){
        return date.format(new Date(timestamp), 'DD.MM.YYYY HH:mm');
      }

      public formatFormTitle( index: string, required: boolean ){
        if( required  && !this.canAdmin()  )
          return index + " (Pflichtfeld)";
        else
          return index;
      }

      public save() {
          let postUrl;
          if( process.env.NODE_ENV === 'development' ) {
            postUrl = `http://localhost:7071/api/addBooking`;
          } else {
            postUrl =`/api/addBooking`
          }

          //Post via Fetch to API
          fetch(`${postUrl}?token=${this.token}`, {
            method: 'POST',
            body: JSON.stringify( this.lintModel( this.eventModel )),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => res.json()).then(res => {
            this.$emit('close');
          });
      }

      public update() {
          let postUrl;
          if( process.env.NODE_ENV === 'development' ) {
            postUrl = `http://localhost:7071/api/updateBooking`;
          } else {
            postUrl =`/api/updateBooking`
          }

          //Post via Fetch to API
          fetch(`${postUrl}?token=${this.token}`, {
            method: 'POST',
            body: JSON.stringify( this.lintModel( this.eventModel )),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => res.json()).then(res => {
            this.$emit('close');
          });
      }

      public del() {
          let postUrl;
          if( process.env.NODE_ENV === 'development' ) {
            postUrl = `http://localhost:7071/api/deleteBooking`;
          } else {
            postUrl =`/api/deleteBooking`
          }

          //Post via Fetch to API
          fetch(`${postUrl}?token=${this.token}&id=${this.eventModel._id}`).then(res => res.json()).then(res => {
            this.$emit('close');
          });
      }

      private lintModel(eventModel: any): any {

        let tempModel = eventModel;

        if( !tempModel.start )
          tempModel.start = this.timeStart;

        if( !tempModel.end )
          tempModel.end = this.timeEnd;

        if( !tempModel.space )
          tempModel.space = this.space;

        delete tempModel.color;
        delete tempModel.timed;
        delete tempModel.name;

          return tempModel;
      }
  }

  
